<template>
  <div class="px-3">
    <!-- <div class="card-accent-text mt-3">Name</div> -->
    <div>
      <input
        type="text"
        id="newProjectName"
        v-model="state.newName"
        placeholder="Project Name"
        class="input-modal-bg p-2 rounded"
        required
        autofocus
      />
    </div>

    <div class="pt-3 pb-0 d-flex w-100 justify-content-end">
      <button @click="closeModal" class="btn-t">Cancel</button>
      <button @click="createProject" class="ml-2 btn-p">Create</button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      state: {
        newName: "",
      },
    };
  },
  methods: {
    createProject() {
      if (this.state.newName != "") {
        this.$store
          .dispatch("apiEvents/createNewProject", {
            projectName: this.state.newName,
            userId: localStorage.getItem("userId"),
          })
          .then(() => {
            this.$root.$emit("bv::hide::modal", "newProjectModal");
            this.state.newName = "";

            //  this.$router.push({ name: "track", params: { id: 0 } });
          });
      }
      //
    },
    closeModal() {
      this.state.newName = "";

      this.$root.$emit("bv::hide::modal", "newProjectModal");
    },

    onSelect_newTrackCatSelect(selected) {
      this.state.newCat = selected;
    },
    onSelect_newTrackStyleSelect(selected) {
      this.state.newStyle = selected;
    },
  },
};
</script>

<style scoped></style>
